



















import Vue from 'vue'
import Card from '@/components/Layout/Card/Card.vue';
import NewsItemBlock from '@/components/Elements/NewsItemBlock.vue';
import NewsItem from '@/components/Elements/NewsItem.vue';

export default Vue.extend({
  components: {
    Card,
    NewsItemBlock,
    NewsItem
  },
  data: () => ({
    newsItem: 'commission',
    newsItems: [],
    selectedNews: false,
    selectedNewsItem: 'commission'
  }),
  computed: {
    localeNewsItems() {
      return this.$t(`latestNewsPage.items.${this.newsItem}`)
    },
  },
  methods: {
    back($event) {
      this.selectedNews = $event;
    },
    getItem($event) {
      this.selectedNews = true;
      this.selectedNewsItem = $event.value;
    },
  }
})
